module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s10-5ee12ae4eeb18daf42faf9022cc10515.jpg";